import React from "react";

export default function CustomPublishedAtComponent({ onInteract, value, data }) {
  return (
    <div onClick={() => onInteract(data)}>
      <div>{value || "Not set"}</div>
    </div>
  );
}
